export default {
  business_name: "The Body Method",
};

export const brands = [
  {
    logo: "/img/brand-1.png",
    name: "Habits",
    levels: [
      {
        number: 1,
        benefit: "10% OFF",
        application: "MOSTRANDO UN CÓDIGO",
        restrictions: "SE APLICA SOBRE UN SOLO PRODUCTO",
        expiration: "1 SEMANA",
      },
      {
        number: 2,
        benefit: "10% OFF",
        application: "MOSTRANDO UN CÓDIGO",
        restrictions: "SE APLICA SOBRE UN SOLO PRODUCTO",
        expiration: "1 SEMANA",
      },
      {
        number: 3,
        benefit: "15% OFF",
        application: "MOSTRANDO UN CÓDIGO",
        restrictions: "SE APLICA SOBRE UN SOLO PRODUCTO",
        expiration: "1 SEMANA",
      },
      {
        number: 4,
        benefit: "15% OFF",
        application: "MOSTRANDO UN CÓDIGO",
        restrictions: "SE APLICA SOBRE UN SOLO PRODUCTO",
        expiration: "1 SEMANA",
      },
      {
        number: 5,
        benefit: "20% OFF",
        application: "MOSTRANDO UN CÓDIGO",
        restrictions: "SE APLICA SOBRE UN SOLO PRODUCTO",
        expiration: "1 SEMANA",
      },
      {
        number: 6,
        benefit: "25% OFF",
        application: "MOSTRANDO UN CÓDIGO",
        restrictions: "SE APLICA SOBRE UN SOLO PRODUCTO",
        expiration: "1 SEMANA",
      },
    ],
    instagram: "@habitsproteins",
  },
  {
    logo: "/img/brand-2.png",
    levels: [
      {
        number: 1,
        benefit: "FREE SHIPPING",
        application: "CÓDIGO DE DESCUENTO EN STIIO WEB",
        restrictions: "1 USO POR USUARIO",
        expiration: "DICIEMBRE 2026",
      },
      {
        number: 2,
        benefit: "15% OFF",
        application: "CÓDIGO DE DESCUENTO EN STIIO WEB",
        restrictions: "1 USO POR USUARIO",
        expiration: "DICIEMBRE 2026",
      },
      {
        number: 3,
        benefit: "20% OFF",
        çapplication: "CÓDIGO DE DESCUENTO EN STIIO WEB",
        restrictions: "1 USO POR USUARIO",
        expiration: "DICIEMBRE 2026",
      },
      {
        number: 4,
        benefit: "25% OFF",
        application: "CÓDIGO DE DESCUENTO EN STIIO WEB",
        restrictions: "1 USO POR USUARIO",
        expiration: "DICIEMBRE 2026",
      },
      {
        number: 5,
        benefit: "GIFT CARD $250",
        application: "CÓDIGO DE DESCUENTO EN STIIO WEB",
        restrictions: "1 USO POR USUARIO",
        expiration: "DICIEMBRE 2026",
      },
      {
        number: 6,
        benefit: "DERMOLIMPIADOR FACIAL FREE",
        application: "CÓDIGO DE DESCUENTO EN STIIO WEB",
        restrictions: "1 USO POR USUARIO",
        expiration: "DICIEMBRE 2026",
      },
    ],
    instagram: "@elisazambrano",
    name: "Eliza Zambrano",
  },
  {
    logo: "/img/brand-3.png",
    levels: [
      {
        number: 1,
        benefit: "FREE SHIPPING",
        application: "CÓDIGO DE DESCUENTO",
        restrictions: "SE PUEDE USAR 2 VECES AL MES",
        expiration: "EL BENEFICIO ES VIGENTE LOS 2 MESES, 2 VECES AL MES.",
      },
      {
        number: 2,
        benefit: "10% OFF EN SITIO WEB",
        application: "CÓDIGO DE DESCUENTO",
        restrictions:
          "NO APLICA CON OTRAS PROMOCIONES, SE PUEDE USAR 2 VECES AL MES",
        expiration: "EL BENEFICIO ES VIGENTE LOS 2 MESES, 2 VECES AL MES.",
      },
      {
        number: 3,
        benefit: "10% OFF + TOTE BAG",
        application: "CÓDIGO DE DESCUENTO",
        restrictions:
          "NO APLICA CON OTRAS PROMOCIONES, SE PUEDE USAR 2 VECES AL MES TOTE BAG SOLO 1 VEZ",
        expiration: "EL BENEFICIO ES VIGENTE LOS 2 MESES, 2 VECES AL MES.",
      },
      {
        number: 4,
        benefit: "15% OFF EN SITIO WEB",
        application: "CÓDIGO DE DESCUENTO",
        restrictions:
          "NO APLICA CON OTRAS PROMOCIONES, SE PUEDE USAR 2 VECES AL MES",
        expiration: "EL BENEFICIO ES VIGENTE LOS 2 MESES, 2 VECES AL MES.",
      },
      {
        number: 5,
        benefit: "BUY 1 GET 1 FREE",
        application: "CÓDIGO DE DESCUENTO",
        restrictions:
          "NO APLICA CON OTRAS PROMOCIONES, SE PUEDE USAR 1 VEZ AL MES",
        expiration: "EL BENEFICIO ES VIGENTE LOS 2 MESES, 1 VEZ",
      },
      {
        number: 6,
        benefit: "SET GRATIS",
        application: "CÓDIGO DE DESCUENTO",
        restrictions:
          "SUBIR STORY CON EL SET PUESTO Y TAGGEAR A LA MARCA EN INSTAGRAM.",
        expiration: "UNICA VEZ",
      },
    ],
    instagram: "@feeleuphoria.wear",
    name: "Euphoria",
  },
  {
    logo: "/img/brand-4.png",
    levels: [
      {
        number: 1,
        benefit: "10% OFF",
        application: "MOSTRAR NIVEL EN LA APP O WEB CON EL CUPÓN",
        restrictions: "CREA TU CUENTA Y AVÍANOS PARA ACTIVAR EL CUPÓN.",
        expiration: "N/A",
      },
      {
        number: 2,
        benefit: "15% OFF",
        application: "MOSTRAR NIVEL EN LA APP O WEB CON EL CUPÓN",
        restrictions: "CREA TU CUENTA Y AVÍANOS PARA ACTIVAR EL CUPÓN.",
        expiration: "N/A",
      },
      {
        number: 3,
        benefit: "20% OFF",
        application: "MOSTRAR NIVEL EN LA APP O WEB CON EL CUPÓN",
        restrictions: "CREA TU CUENTA Y AVÍANOS PARA ACTIVAR EL CUPÓN.",
        expiration: "N/A",
      },
      {
        number: 4,
        benefit: "20% OFF",
        application: "MOSTRAR NIVEL EN LA APP O WEB CON EL CUPÓN",
        restrictions: "CREA TU CUENTA Y AVÍANOS PARA ACTIVAR EL CUPÓN.",
        expiration: "N/A",
      },
      {
        number: 5,
        benefit: "UNA TANK TOP DE REGALO EN COMPRA DE 1,200 PESOS",
        application: "SOLO EN TIENDA, SUBIENDO STORY",
        restrictions: "NO SE PUEDE PAGINA WEB",
        expiration: "N/A",
      },
      {
        number: 6,
        benefit: "GIFT CARD DE $600 PESOS",
        application: "SOLO EN TIENDA, SUBIENDO STORY",
        restrictions: "NO SE PUEDE PAGINA WEB",
        expiration: "N/A",
      },
    ],
    instagram: "@mycrazyfit_",
    name: "Crazy Fit",
  },
  {
    logo: "/img/brand-6.png",
    levels: [
      {
        number: 1,
        benefit: "10% OFF",
        application: "CÓDIGO DE DESCUENTO",
        restrictions: "COMPRA MÍNIMA $800 PESOS",
      },
      {
        number: 2,
        benefit: "10% OFF",
        application: "CÓDIGO DE DESCUENTO",
        restrictions: "COMPRA MÍNIMA $800 PESOS",
      },
      {
        number: 3,
        benefit: "15% OFF",
        application: "CÓDIGO DE DESCUENTO",
        restrictions: "COMPRA MÍNIMA $800 PESOS",
      },
      {
        number: 4,
        benefit: "15% OFF",
        application: "CÓDIGO DE DESCUENTO",
        restrictions: "COMPRA MÍNIMA $800 PESOS",
      },
      {
        number: 5,
        benefit: "20% OFF",
        application: "CÓDIGO DE DESCUENTO",
        restrictions: "COMPRA MÍNIMA $800 PESOS",
      },
      {
        number: 6,
        benefit: "20% OFF",
        application: "CÓDIGO DE DESCUENTO",
        restrictions: "COMPRA MÍNIMA $800 PESOS",
      },
    ],
    instagram: "@Fiera_activewear",
    name: "Fiera",
  },
  {
    logo: "/img/brand-7.png",
    levels: [
      {
        number: 1,
        benefit: "10% OFF",
        application: "CÓDIGO PERSONALIZADO",
        restrictions: "SE PUEDE USAR 1 VEZ",
        expiration: "",
      },
      {
        number: 2,
        benefit: "15% + DAILY AFFIRMATIONS (LINK)",
        application: "CÓDIGO PERSONALIZADO",
        restrictions: "SE PUEDE USAR 1 VEZ",
        expiration: "",
      },
      {
        number: 3,
        benefit: "20% + SUGAR ESCAPE (PLANNER DIGITAL)",
        application: "CÓDIGO PERSONALIZADO",
        restrictions: "SE PUEDE USAR 1 VEZ",
        expiration: "",
      },
      {
        number: 4,
        benefit: "20% + 20% OFF LIBRO - GUÍA ANTI-INFLAMATORIA",
        application: "CÓDIGO PERSONALIZADO",
        restrictions: "SE PUEDE USAR 1 VEZ",
        expiration: "",
      },
      {
        number: 5,
        benefit: "15% POR UN AÑO EN CARMARI ACTIVE",
        application: "CÓDIGO PERSONALIZADO",
        restrictions: "",
        expiration: "1 AÑO",
      },
      {
        number: 6,
        benefit: "LINK DE AFILIADOS - 10% COMISIÓN",
        application: "CÓDIGO PERSONALIZADO",
        restrictions: "",
        expiration: "1 AÑO",
      },
    ],
    instagram: "@carmariactive",
    name: "Carmari Active",
  },
  {
    logo: "/img/brand-8.png",
    levels: [
      {
        number: 1,
        benefit:
          "GRABACIÓN MEDITACIÓN Y EXPLICACIÓN, PRINCIPIOS DE LA ATENCIÓN",
        application: "",
        restrictions: "",
        expiration: "",
      },
      {
        number: 2,
        benefit:
          "GRABACIÓN MEDITACIÓN Y EXPLICACIÓN, ABANDONANDO CREENCIAS LIMITANTES",
        application: "",
        restrictions: "",
        expiration: "",
      },
      {
        number: 3,
        benefit: "50% SESIÓN DE COACHING ONLINE",
        application: "",
        restrictions: "",
        expiration: "",
      },
      {
        number: 4,
        benefit: "SESIONES DE COACHING ONLINE REGALO",
        application: "",
        restrictions: "",
        expiration: "",
      },
      {
        number: 5,
        benefit: "50% PROGRAMA REGENERANDO MI SER",
        application: "",
        restrictions: "",
        expiration: "",
      },
      {
        number: 6,
        benefit: "PROGRAMA REGENERANDO MI SER GRATIS",
        application: "",
        restrictions: "",
        expiration: "",
      },
    ],
    instagram: "@wendyquirozb_",
    name: "Wendy Quiroz",
  },
  {
    logo: "/img/brand-9.png",
    levels: [
      {
        number: 1,
        benefit: "10% DE DESCUENTO",
        application: "PAGINA WEB",
        restrictions: "",
        expiration: "",
      },
      {
        number: 2,
        benefit: "10% DE DESCUENTO",
        application: "PAGINA WEB",
        restrictions: "",
        expiration: "",
      },
      {
        number: 3,
        benefit: "15% DE DESCUENTO",
        application: "PAGINA WEB",
        restrictions: "",
        expiration: "",
      },
      {
        number: 4,
        benefit: "15% DE DESCUENTO",
        application: "PAGINA WEB",
        restrictions: "",
        expiration: "",
      },
      {
        number: 5,
        benefit: "20% DE DESCUENTO",
        application: "PAGINA WEB",
        restrictions: "",
        expiration: "",
      },
      {
        number: 6,
        benefit: "1 PZ DAYDREAM + BOLSA VERDE",
        application: "PAGINA WEB",
        restrictions: "",
        expiration: "",
      },
    ],
    instagram: "@endless.luxe",
    name: "Endless Luxe",
  },
  {
    logo: "/img/brand-10.png",
    levels: [
      {
        number: 1,
        benefit: "ENVÍO GRATIS",
        application: "PAGINA WEB",
        restrictions: "1 SOLO USO",
        expiration: "",
      },
      {
        number: 2,
        benefit: "SUERO RHEBOOSTER 15ML",
        application: "DM",
        restrictions: "1 SOLO USO",
        expiration: "",
      },
      {
        number: 3,
        benefit: "SUERO RHEBOOSTER 30ML",
        application: "PAGINA WEB",
        restrictions: "1 SOLO USO",
        expiration: "",
      },
      {
        number: 4,
        benefit: "10% OFF",
        application: "PAGINA WEB",
        restrictions: "1 SOLO USO",
        expiration: "",
      },
      {
        number: 5,
        benefit: "15% OFF",
        application: "PAGINA WEB",
        restrictions: "1 SOLO USO",
        expiration: "",
      },
      {
        number: 6,
        benefit: "FILTRO RHEFRESH",
        application: "PAGINA WEB",
        restrictions: "1 SOLO USO",
        expiration: "",
      },
    ],
    instagram: "@rhe.face",
    name: "Rhe Face",
  },
];